import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listScans, type AdminScanSummary } from '../lib/api';
import { theme } from '../theme';

export function FailuresPage() {
  const [scans, setScans] = useState<AdminScanSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listScans({ outcome: 'failure', limit: 100 })
      .then((res) => setScans(res.scans))
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1>Failed Scans</h1>
      <p style={{ color: theme.text.secondary, fontSize: 13 }}>
        Scans that didn't produce a report — useful for spotting fleet-wide adapter or car-class
        issues.
      </p>
      {error && <p style={{ color: theme.status.error }}>Error: {error}</p>}
      {loading && <p>Loading…</p>}
      {!loading && scans.length === 0 && <p>No failed scans recorded — nice!</p>}
      {!loading && scans.length > 0 && (
        <table style={{ width: '100%' }}>
          <thead>
            <tr style={{ background: theme.surface.header }}>
              <Th>Scanned</Th>
              <Th>ID</Th>
              <Th>Vehicle</Th>
              <Th>Failure reason</Th>
              <Th>Origin</Th>
              <Th>Actions</Th>
            </tr>
          </thead>
          <tbody>
            {scans.map((s) => (
              <tr key={s.scanId} style={{ borderBottom: `1px solid ${theme.surface.border}` }}>
                <Td>{new Date(s.scannedAt).toLocaleString()}</Td>
                <Td>
                  <span style={{ fontFamily: theme.fonts.mono, fontSize: 12 }}>
                    {s.scanShortcodeBody ? `OB-${s.scanShortcodeBody}` : `${s.scanId.slice(0, 8)}…`}
                  </span>
                </Td>
                <Td>
                  {s.make ?? '?'} {s.model ?? '?'} {s.modelYear ?? ''}
                </Td>
                <Td>{s.failureReason ?? '—'}</Td>
                <Td>{s.scanOrigin ?? '—'}</Td>
                <Td>
                  <Link to={`/scans/${s.scanId}`}>Details</Link>
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function Th({ children }: { children: React.ReactNode }) {
  return (
    <th
      style={{
        textAlign: 'left',
        padding: '8px 12px',
        fontSize: 12,
        color: theme.text.secondary,
        fontWeight: 600,
      }}
    >
      {children}
    </th>
  );
}
function Td({ children }: { children: React.ReactNode }) {
  return <td style={{ padding: '8px 12px', fontSize: 13 }}>{children}</td>;
}
